import I18n from "common/i18n";
import { Layout } from "features/creator/tutorial/top/stages/Layout";
import { Title } from "../Title";

const Step = (props: { back: () => void; next: () => void; close: () => void }) => {
  const { back, next, close } = props;

  return (
    <Layout back={back} next={next} close={close}>
      <Title activeStep={2} />

      <div className="flex-col-el items-start justify-center w-[312px]">
        <p className="text-body text-textcolor-black text-[22px] leading-9 whitespace-pre">
          {I18n.locale === "ja"
            ? "ここでは\nアイデアしだいで\nじゆうに アプリを\nつくったり、"
            : "ここでは\nアイデア次第で\n自由にアプリを\n作ったり、"}
        </p>
      </div>
    </Layout>
  );
};

export default Step;
